// import Hero from '../sections/Hero'          // ← original video hero (kept as backup)
import HeroScrollSequence from '../sections/HeroScrollSequence'
import TrustBar from '../sections/TrustBar'
import ValueProposition from '../sections/TheProblem'        // Section 1 — The Problem
import ProcessTimeline from '../sections/TheDifference'      // Section 2 — The Difference
import TechnologyShowcase from '../sections/WhatThatFeelsLike' // Section 3 — What That Feels Like
import WhatThisIsnt from '../sections/WhatThisIsnt'          // Section 4 — What This Isn't
import TheBridgeBelief from '../sections/TheBridgeBelief'    // Section 5 — The Bridge Belief
import WhoThisIsFor from '../sections/WhoThisIsFor'          // Section 6 — Who This Is For
import CTA from '../sections/CTA'
import Footer from '../sections/Footer'

const HomePage = () => {
  return (
    <>
      <HeroScrollSequence />
      <TrustBar />
      <ValueProposition />
      <ProcessTimeline />
      <TechnologyShowcase />
      <WhatThisIsnt />
      <TheBridgeBelief />
      <WhoThisIsFor />
      <CTA />
      <Footer />
    </>
  )
}

export default HomePage
